import { useEffect, useState } from "react";
import { useShowAllOdpHooks } from "../../../utils/infrastructure/OdpUtils";
import useDebounce from "../../../utils/useDebounceHooks";

export default function OdpPicker({ value, onChange, onManual }) {
  const [inputSearch, setInputSearch] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [filter, setFilter] = useState({ q: "" });

  const { data: odps, loading } = useShowAllOdpHooks({ filter });
  const debouncedSearchTerm = useDebounce(inputSearch, 500);

  // Initialize selected value from prop
  const [selected, setSelected] = useState(value || null);

  useEffect(() => {
    if (debouncedSearchTerm) {
      setFilter((prev) => ({
        ...prev,
        q: debouncedSearchTerm,
      }));
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    // Update selected when value prop changes
    setSelected(value);
  }, [value]);

  const onClickOdp = (odp) => {
    setSelected(odp);
    onChange(odp); // Pass the entire object, not just string
    setInputSearch("");
    setEditMode(false);
  };

  const handleEditModeToggle = () => {
    setInputSearch("");
    setFilter({ ...filter, q: "" });
    setEditMode(true);
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setInputSearch("");
  };

  return (
    <>
      {editMode ? (
        <div className="input-group mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="cari ODP berdasar kode ODP ..."
            value={inputSearch}
            onChange={(event) => setInputSearch(event.target.value)}
          />
          <div className="input-group-append">
            <button className="btn btn-danger" type="button" onClick={handleCancelEdit}>
              <div className="fa fa-rotate-left"></div>
            </button>
          </div>
        </div>
      ) : (
        <div className="input-group mb-2">
          <input
            type="text"
            className="form-control"
            value={selected?.code || ""}
            disabled={!editMode}
            placeholder="Pilih ODP..."
            style={{ background: "white" }}
          />
          <div className="input-group-append">
            <button className="btn btn-primary" type="button" onClick={handleEditModeToggle}>
              <div className="fa fa-chevron-down"></div>
            </button>
          </div>
        </div>
      )}

      {editMode && (
        <div className="list-group">
          <div className="list-group-item bg-light font-weight-bold py-1">Pilih ODP:</div>
          {odps.length === 0 && !loading && (
            <div className="list-group-item">
              <div className="mb-2">Tidak ada ODP yang ditemukan ...</div>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => onManual(inputSearch.trim())}
              >
                Input Manual ODP ({inputSearch})
              </button>
            </div>
          )}
          {loading ? (
            <div className="list-group-item">Mencari ...</div>
          ) : (
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {odps.map((odp, index) => (
                <button
                  key={index}
                  type="button"
                  className="list-group-item list-group-item-action"
                  onClick={() => onClickOdp(odp)}
                >
                  {odp.code}
                  {selected?.id === odp.id && <i className="fa fa-check text-success ml-2"></i>}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
